(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }

    // set svg background
    setProductRecommendationsBackground();

    /**
    * Slick module - pdp
    */
    let slickWrapper = $('#product-recommendations').children('ul');
    $(slickWrapper).slick({
      prevArrow: false,
      nextArrow: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      appendDots: '#product-recommendations-dots',
      centerMode: false,
      infinite: true,
      mobileFirst: true,
      dots: false,
      variableWidth: true,
      responsive: [
        {
          // sm
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            variableWidth: false
          }
        },
        {
          // md
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: false,
            variableWidth: false
          }
        },
        {
          // lg
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            variableWidth: false
          }
        },
        {
          // xl
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            variableWidth: false
          }
        },
      ]
    });
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
    // set svg background
    setShopTheLookBackground();

    /**
    * Slick module - pdp
    */
    let slickWrapper = $('#shop-the-look').children('ul');
    $(slickWrapper).slick({
    prevArrow: false,
    nextArrow: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: '#shop-the-look-dots',
    centerMode: false,
    infinite: true,
    mobileFirst: true,
    dots: true,
    variableWidth: true,
    responsive: [
        {
        // sm
        breakpoint: 576,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            variableWidth: false
        }
        },
        {
        // md
        breakpoint: 768,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            variableWidth: false
        }
        },
        {
        // lg
        breakpoint: 992,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            variableWidth: false
        }
        },
        {
        // xl
        breakpoint: 1200,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            variableWidth: false
        }
        },
    ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-slider-pdp"] && !Shopify.designMode) return;
  try {
    
  setUGCSliderBackground();

  let slickWrapper = $('#ugc-slider-pdp').children('ul');
  $(slickWrapper).slick({
  prevArrow: false,
  nextArrow: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  appendDots: '#ugc-slider-pdp-dots',
  centerMode: false,
  infinite: true,
  mobileFirst: true,
  dots: false,
  variableWidth: true,
  responsive: [
      {

      breakpoint: 576,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          variableWidth: false
      }
      },
      {

      breakpoint: 768,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          variableWidth: false
      }
      },
      {
      breakpoint: 992,
      settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          variableWidth: false
      }
      },
      {
      breakpoint: 1200,
      settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          dots: true,
          variableWidth: false
      }
      },
  ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-slider"] && !Shopify.designMode) return;
  try {
    
    // set svg background
    setUGCSliderBackground();

    /**
    * Slick module - pdp
    */
    let slickWrapper = $('#ugc-slider').children('ul');
    $(slickWrapper).slick({
    prevArrow: false,
    nextArrow: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: '#ugc-slider-dots',
    centerMode: false,
    infinite: true,
    mobileFirst: true,
    dots: true,
    variableWidth: true,
    responsive: [
        {
        // sm
        breakpoint: 576,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            variableWidth: false
        }
        },
        {
        // md
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            variableWidth: false
        }
        },
        {
        // lg
        breakpoint: 992,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            variableWidth: false
        }
        },
        {
        // xl
        breakpoint: 1200,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            variableWidth: false
        }
        },
    ]
    });

  } catch(e) { console.error(e); }
})();
})();
